module.exports = __webpack_public_path__ + "media/images/pc/stores/nara/nara_concept_03-7b4800d9991dc29ce4440a506929d8dd.jpg";